import ProgressBarComp from './ProgressBar';
import LoaderComp from './Loader';

export const ProgressBar = ProgressBarComp;

export const Loader = LoaderComp;
